import { postShifts } from './PostShifts';

export const MultiDayShiftsService = {
  postShifts,
};
